import React from 'react';
import makeStyles from '@material-ui/core/styles/makeStyles';
import CircularProgress from '@material-ui/core/CircularProgress';
import Typography from '@material-ui/core/Typography';

const useStyles = makeStyles(theme => ({
  marginTop: {
    marginTop: theme.spacing(2)
  },
  container: {
    marginTop: theme.spacing(2),
    display: 'flex'
  },
  progressRoot: {
    marginRight: theme.spacing(1),
    outline: 'none'
  }
}));

const Progress = ({ children }) => {
  const classes = useStyles();
  return (
    <div className={classes.container}>
      <CircularProgress
        size={16}
        thickness={2}
        color="secondary"
        classes={{ root: classes.progressRoot }}
      />
      <Typography variant="body2">{children}</Typography>
    </div>
  );
};

export default Progress;
